import React, { ReactElement } from "react";

export default function ShopIcon({ icon }: { icon: string | null }): ReactElement {
	return <img src={icon ? `https://cdn.ulozdoklad.com/${icon}` : "/receipt.svg"} alt={icon} className="shop-icon" />;
}
